import { FullStory } from '@fullstory/browser';

function fullStoryTrack(name: string, properties: { metadata: string }) {
    FullStory('trackEvent', {
        name,
        properties,
    });
}

export default {
    fullStoryTrack,
};
